import styled from "styled-components";
import {
  GrayColors,
  SolutionColorVariables,
  TextColorNames,
} from "@smartsuite/types";

export const EmptyInputsStyled = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  min-height: 450px;
  padding: 20px;

  background: transparent;
`;

export const ErrorTitle = styled.div`
  margin-top: 10px;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 22px;
  line-height: 30px;
  color: var(--typo-primary, ${TextColorNames.primary});
`;

export const ErrorText = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: var(--tertiary, ${TextColorNames.tertiary});
`;

export const ErrorSectionWrapper = styled.div`
  text-align: center;
`;

export const BackButton = styled.button`
  margin-top: 30px;
  padding: 7px 15px;
  background: ${SolutionColorVariables.sc1};
  border-radius: 16px;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: ${GrayColors["G-0"]};
`;
